import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import zh from './locales/zh.json';
import ru from './locales/ru.json';
import es from './locales/es.json';
import vi from './locales/vi.json';
import ms from './locales/ms.json';
import id from './locales/id.json';
import th from './locales/th.json';
import ar from './locales/ar.json';

export const SUPPORTED_LANGS = ['en', 'zh', 'ru', 'es', 'vi', 'ms', 'id', 'th', 'ar'] as const;
export type SupportedLang = typeof SUPPORTED_LANGS[number];

export const languages = [
  { code: 'en', nativeName: 'English', flag: '🇺🇸' },
  { code: 'zh', nativeName: '中文', flag: '🇨🇳' },
  { code: 'ru', nativeName: 'Русский', flag: '🇷🇺' },
  { code: 'es', nativeName: 'Español', flag: '🇪🇸' },
  { code: 'vi', nativeName: 'Tiếng Việt', flag: '🇻🇳' },
  { code: 'ms', nativeName: 'Bahasa Melayu', flag: '🇲🇾' },
  { code: 'id', nativeName: 'Bahasa Indonesia', flag: '🇮🇩' },
  { code: 'th', nativeName: 'ไทย', flag: '🇹🇭' },
  { code: 'ar', nativeName: 'العربية', flag: '🇸🇦' },
];

const resources = {
  en: { translation: en },
  zh: { translation: zh },
  ru: { translation: ru },
  es: { translation: es },
  vi: { translation: vi },
  ms: { translation: ms },
  id: { translation: id },
  th: { translation: th },
  ar: { translation: ar },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: [...SUPPORTED_LANGS],
    nonExplicitSupportedLngs: true,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'luna_portal_locale',
    },
  });

export default i18n;
